import React, { useEffect } from 'react';
import styles from './styles.module.less';
// import ManagePic from '../../../common/assets/images/LeftImg1.png';
// ../../../assets/ManageProfile.jpg
// import { EditOutlined, DownloadOutlined } from '@ant-design/icons';
// import downloadIcon from '@/common/assets/images/DownloadIcon.svg';
import EditIcon from '@/common/assets/images/EditIcon.svg';
import { useNavigate } from 'react-router-dom';
import {
  Row,
  Col,
  // Typography,
  // Button,
  // Divider,
  Tabs,
  Progress
} from 'antd';
import Aboutme from './Aboutme';
import FamilyDetails from './FamilyDetails';
import Education from './Education';
import Horoscope from './Horoscope';
import Contact from './Contact';
import DesiredPartner from './DesiredPartner';
import Membership from './Membership';

// const { Text } = Typography;
const { TabPane } = Tabs;

const ManageProfile = ({ profiles, user_data, payment_data }) => {
  const profileNames = profiles?.map((profile) => profile.profile_name);
  const navigate = useNavigate();
  useEffect(() => {
    profiles?.forEach((profile) => {
      console.log('Profile Name:', profile.profile_name);
    });
  }, [profiles]);

  // console.log('user_data', user_data?.user_score);
  const percent = user_data?.user_score;
  // user_data?.user_score;
  // const text = 'Rohit';
  // const conicColors = {
  //   '30%': 'red',
  //   '50%': 'orange',
  //   '80%': 'yellow',
  //   '100%': 'green'
  // };
  const getStrokeColor = (percent) => {
    if (percent <= 30) return '#ff4d4f'; // Red
    if (percent <= 50) return '#fa8c16'; // Orange
    if (percent <= 80) return '#fadb14'; // Yellow
    return '#52c41a'; // Green
  };

  const handleEdit = () => {
    navigate(`/editprofile`);
  };

  // const matUserData = localStorage.getItem('MAT-User');
  // const matUserObject = JSON.parse(matUserData);
  // const profile_unique_id = matUserObject?.user_details?.profile_unique_id;

  return (
    <div className={styles.maincontainer}>
      {/* <Row span={24}>
        <Col>
          <img
            src={ManagePic}
            alt="manage profile pic "
            style={{
              width: '485px',
              height: '640px',
              paddingBottom: '200px',
              position: 'fixed'
            }}
          />
        </Col>
      </Row> */}

      <div className={styles.editOuter}>
        <div className={styles.singleContainer}>
          {/* <Row getter={24} style={{ width: '100%' }}>
            <Col getter={8}>
              <img src={ManagePic} />
            </Col> */}
          <Row
            getter={24}
            style={{ width: '100%' }}
            className={styles.aboutimgstyles}
          >
            <Col
              xl={7}
              lg={24}
              md={24}
              sm={24}
              xs={24}
              className={styles.leftcontent}
            >
              <div className={styles.leftimgcontainer}>
                {/* <img src={LeftImg} /> */}
                <div className={styles.overlayText}>
                  <h2 className={styles.title}>THE TALE OF</h2>
                  <h1 className={styles.bigTitle}>TWO</h1>
                </div>
              </div>
            </Col>
            {/* <Col
              style={{
                paddingLeft: '515px',
                paddingTop: '10px',
                paddingRight: '100px'
              }}
            >
              <Row className={styles.ManageHeader}> Sanjana Chowdary </Row>
              <Row className={styles.firstRow}>
                <Col className={styles.percentage}>
                  {' '}
                  90% Away to find teh right match
                </Col>
                <Col>
                  <Button className={styles.btnHead}>
                    <EditOutlined />
                    Edit Profile
                  </Button>
                  <Divider type="vertical" className={styles.verticalLine} />
                  <Button className={styles.btnHead}>
                    <DownloadOutlined />
                    Download
                  </Button>
                </Col>
              </Row> */}
            <Col
              xl={16}
              lg={24}
              md={24}
              sm={24}
              xs={24}
              className={styles.rightcontent}
            >
              <div className={styles.detailSide}>
                <div className={styles.detailName}>
                  <div className={styles.nameflex}>
                    {/* <h1 className={styles.dName}>Sanjana Chowdary</h1> */}
                    {/* <h1 className={styles.dName}>{profileNames}</h1> */}
                    <div className={styles.idname}>
                      <h1 className={styles.dName}> {profileNames} </h1>
                      {/* <span> {profile_unique_id} </span> */}
                    </div>
                    {/* <div className={styles.matchpercent}>
                      <h6>
                        <span>96%</span> Away to find the right match
                      </h6>
                    </div> */}
                    <Row gutter={[8, 8]} wrap>
                      <Col className={styles.progressname}>
                        <Progress
                          size="small"
                          type="circle"
                          percent={percent}
                          // strokeColor={conicColors}
                          strokeColor={getStrokeColor(percent)}
                        />
                        <h6 className={styles.matchpercent}>
                          away to find your life partner
                        </h6>
                      </Col>
                      {/* <Col className={styles.progressname}>
                        <div className={styles.anticlockwise}>
                          <Progress
                            size="small"
                            type="dashboard"
                            percent={percent}
                            gapDegree={0}
                            strokeColor={getStrokeColor(percent)}
                          />
                        </div>
                        <h6 className={styles.matchpercent}>
                          Away to find your life partner
                        </h6>
                      </Col> */}
                    </Row>
                  </div>
                  <div className={styles.changes}>
                    <div className={styles.textContainer}>
                      {/* <img
                        src={EditIcon}
                        alt="Edit Profile"
                        className={styles.icon}
                      />
                      <div>Edit</div> */}
                      <button
                        onClick={handleEdit}
                        className={styles.editButton}
                      >
                        <img
                          src={EditIcon}
                          alt="Edit Profile"
                          className={styles.icon}
                        />
                        <div>Edit</div>
                      </button>
                    </div>

                    {/* <div className={styles.vBorder}></div> */}

                    {/* <div className={styles.textContainer}>
                      <img
                        src={downloadIcon}
                        alt="Download Profile"
                        className={styles.icon}
                      />
                      <div>Download</div>
                    </div> */}
                  </div>
                </div>
              </div>
              {/*  */}
              {/* <Divider type="horizontal" className={styles.horizontalLine} /> */}
              {/* Tabs Section */}
              <div>
                <div className={styles.detailsOuter}>
                  <div className={styles.detailsInner}>
                    <div className={styles.detailsInside}>
                      {/* <div className={styles.searchTab}></div> */}
                      <Row className={styles.info}>
                        <Tabs
                          defaultActiveKey="1"
                          // centered
                          className={styles.tabstyles}
                          style={{
                            fontFamily: 'Teachers',
                            fontSize: '12px'
                            // paddingLeft: '50px'
                          }}
                        >
                          <TabPane
                            tab="ABOUT ME"
                            key="1"
                            // style={{ fontSize: '12px' }}
                          >
                            <Aboutme
                              profiles={profiles}
                              user_data={user_data}
                            />
                          </TabPane>
                          <TabPane tab="FAMILY DETAILS" key="2">
                            <FamilyDetails
                              profiles={profiles}
                              user_data={user_data}
                            />
                          </TabPane>
                          <TabPane tab="EDUCATION & CAREER" key="3">
                            <Education
                              profiles={profiles}
                              user_data={user_data}
                            />
                          </TabPane>
                          <TabPane tab="HOROSCOPE" key="4">
                            <Horoscope
                              profiles={profiles}
                              user_data={user_data}
                            />
                          </TabPane>
                          <TabPane tab="CONTACT" key="5">
                            <Contact
                              profiles={profiles}
                              user_data={user_data}
                            />
                          </TabPane>
                          <TabPane tab="DESIRED PARTNER" key="6">
                            <DesiredPartner
                              profiles={profiles}
                              user_data={user_data}
                            />
                          </TabPane>
                          <TabPane tab="MEMBERSHIP" key="7">
                            <Membership
                              profiles={profiles}
                              user_data={user_data}
                              payment_data={payment_data}
                            />
                          </TabPane>
                        </Tabs>
                      </Row>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default ManageProfile;
